// Loader oficial TheConect (eco-spinner) — réplica fiel do original (Jt do bundle).
// Arcos girando (ecoSpin/ecoSpinReverse) + raio central pulsante + brilho + ondas + texto.
const SIZES = {
  sm: { container: 80, bolt: 28, stroke: 2.5, text: 'text-xs' },
  md: { container: 120, bolt: 40, stroke: 3, text: 'text-sm' },
  lg: { container: 160, bolt: 56, stroke: 4, text: 'text-base' },
}

export default function Loader({ size = 'md', text = 'Carregando...' }) {
  const r = SIZES[size] || SIZES.md
  const c = r.container / 2
  const f = c - 10, u = c - 20, h = c - 3
  const x = 2 * Math.PI * f, p = 2 * Math.PI * u, y = 2 * Math.PI * h
  const orig = { transformOrigin: `${c}px ${c}px` }

  return (
    <div className="flex flex-col items-center justify-center gap-5">
      <div className="relative" style={{ width: r.container, height: r.container }}>
        {/* brilho */}
        <div className="absolute rounded-full eco-glow" style={{ inset: -8, background: 'radial-gradient(circle, rgba(255,204,0,0.15) 0%, transparent 65%)' }} />
        <svg width={r.container} height={r.container} viewBox={`0 0 ${r.container} ${r.container}`} className="absolute inset-0" style={{ overflow: 'visible' }}>
          <defs>
            <linearGradient id="ecoArc1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ffd633" /><stop offset="50%" stopColor="#ffcc00" /><stop offset="100%" stopColor="#b34c00" />
            </linearGradient>
            <linearGradient id="ecoArc2" x1="100%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#ffe066" /><stop offset="50%" stopColor="#ff8a1a" /><stop offset="100%" stopColor="#047857" />
            </linearGradient>
            <linearGradient id="ecoArc3" x1="0%" y1="100%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#fff5cc" /><stop offset="100%" stopColor="#ff6c00" />
            </linearGradient>
            <linearGradient id="ecoBolt" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#ffe066" /><stop offset="40%" stopColor="#ffcc00" /><stop offset="100%" stopColor="#b34c00" />
            </linearGradient>
          </defs>
          {/* trilhas */}
          <circle cx={c} cy={c} r={h} fill="none" stroke="rgba(255,204,0,0.06)" strokeWidth={r.stroke * 0.5} />
          <circle cx={c} cy={c} r={f} fill="none" stroke="rgba(255,204,0,0.08)" strokeWidth={r.stroke * 0.6} />
          <circle cx={c} cy={c} r={u} fill="none" stroke="rgba(255,204,0,0.06)" strokeWidth={r.stroke * 0.4} />
          {/* arcos animados */}
          <circle cx={c} cy={c} r={h} fill="none" stroke="url(#ecoArc3)" strokeWidth={r.stroke * 0.7} strokeLinecap="round"
            strokeDasharray={`${y * 0.3} ${y * 0.7}`} style={{ ...orig, animation: 'ecoSpin 2.5s linear infinite' }} />
          <circle cx={c} cy={c} r={f} fill="none" stroke="url(#ecoArc1)" strokeWidth={r.stroke} strokeLinecap="round"
            strokeDasharray={`${x * 0.35} ${x * 0.15} ${x * 0.12} ${x * 0.38}`} style={{ ...orig, animation: 'ecoSpin 1.5s linear infinite' }} />
          <circle cx={c} cy={c} r={f} fill="none" stroke="#ffd633" strokeWidth={r.stroke * 0.4} strokeLinecap="round"
            strokeDasharray={`${x * 0.1} ${x * 0.9}`} opacity={0.7} style={{ ...orig, animation: 'ecoSpin 1.5s linear infinite' }} />
          <circle cx={c} cy={c} r={u} fill="none" stroke="url(#ecoArc2)" strokeWidth={r.stroke * 0.8} strokeLinecap="round"
            strokeDasharray={`${p * 0.25} ${p * 0.75}`} style={{ ...orig, animation: 'ecoSpinReverse 2s linear infinite' }} />
          <circle cx={c} cy={c} r={u} fill="none" stroke="#ffe066" strokeWidth={r.stroke * 0.35} strokeLinecap="round"
            strokeDasharray={`${p * 0.08} ${p * 0.42} ${p * 0.08} ${p * 0.42}`} opacity={0.6} style={{ ...orig, animation: 'ecoSpinReverse 2s linear infinite' }} />
          <circle cx={c} cy={c} r={h} fill="none" stroke="rgba(255,108,0,0.25)" strokeWidth={1} strokeDasharray="3 7" style={{ ...orig, animation: 'ecoSpinReverse 4s linear infinite' }} />
          <circle cx={c} cy={c} r={u} fill="none" stroke="rgba(255,204,0,0.15)" strokeWidth={1} strokeDasharray="2 9" style={{ ...orig, animation: 'ecoSpin 6s linear infinite' }} />
        </svg>
        {/* raio central */}
        <div className="absolute top-1/2 left-1/2 eco-bolt" style={{ marginLeft: -r.bolt / 2, marginTop: -r.bolt / 2 }}>
          <svg width={r.bolt} height={r.bolt} viewBox="0 0 48 48" fill="none">
            <path d="M28 4L12 26h10l-4 18L34 22H24l4-18z" fill="url(#ecoBolt)" stroke="#b34c00" strokeWidth="1.2" strokeLinejoin="round" />
            <path d="M26 8L15 25h7l-3 13L33 23H26l3-15z" fill="rgba(255,255,255,0.3)" strokeLinejoin="round" />
          </svg>
        </div>
        {/* ondas */}
        <div className="absolute inset-0 rounded-full eco-ring" style={{ border: '1.5px solid rgba(255,204,0,0.35)' }} />
        <div className="absolute inset-0 rounded-full eco-ring" style={{ border: '1px solid rgba(255,108,0,0.25)', animationDelay: '0.6s' }} />
      </div>
      {text && (
        <div className="flex flex-col items-center gap-1.5">
          <p className={`${r.text} font-semibold bg-gradient-to-r from-accent-600 via-primary-600 to-cyan-600 bg-clip-text text-transparent eco-text`}>{text}</p>
          <div className="w-32 h-0.5 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full w-1/3 bg-gradient-to-r from-transparent via-accent-500 to-transparent rounded-full eco-shimmer" />
          </div>
        </div>
      )}
    </div>
  )
}
